<template>
  <el-container style="margin:0 auto;height:100vh;" id="loginClass">
    <div v-if="isMobile==false">
      <el-header style="padding:0px; height:auto;">
        <div style="height:67px;background-color: #fff;padding:13px 50px 0;position: relative;" class="header-first">
          <a id="collagelogo" ></a>
        </div>
      </el-header>
      <!-- 电脑 -->
      <el-main id="loginMain" style="padding-top:60px;" >
        <div style="text-align: center;position: relative;height: 80vh;">
          <img src="/static/img/login-bg.png" alt="computer" style="width:100%;max-width:1513px">
          <div class='loginForm' >
            <h1 style="margin-bottom:30px;">用户登录</h1>
            <el-form ref='loginForm' label-position="right" size="medium"  :model="loginForm" :rules='rules'>
              <el-form-item  prop='username'>
                <el-input v-model.trim="loginForm.username" autofocus placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item  prop='password'>
                <el-input v-model.trim="loginForm.password" type='password' @keyup.enter.native="submitForm" placeholder="请输入密码"></el-input>
              </el-form-item>
              <template v-if="showVcode">
              <el-form-item  prop='vcode'>
                <el-row :gutter="10">
                    <el-col :span="11">
                      <el-input v-model="loginForm.vcode" @keyup.enter.native="submitForm" placeholder="请输入验证码"></el-input>
                    </el-col>
                    <el-col :span="5">
                      <img :src="vcodeSrc">
                    </el-col>
                    <el-col :span="8" style="text-align:right ">
                      <span id="changeVcode" @click="refreshVcode">换一张</span>
                    </el-col>
                </el-row>
              </el-form-item>
              </template>
              <el-form-item>
                <el-button type="primary" @click="submitForm">登录</el-button>
                <!-- <el-button @click="resetForm">重置</el-button> -->
              </el-form-item>
              <div style="font-size:12px;line-height:25px;color:red">推荐使用谷歌浏览器</div>
              <p style="font-size:12px;line-height:25px">
                忘记登录密码,学生用户请联系任课教师;<br>
                教师用户请联系系统管理员</p>
            </el-form>
          </div>
        </div>
      </el-main>
    </div>
    <div v-else id="contentId">
      <el-header style="padding:0px; height:auto;">
        <div style="height:67px;background-color: #fff;padding:13px 40px 0;" class="header-first">
          <a id="collagelogo2" ></a>
        </div>
      </el-header>
      <!-- 手机 -->
      <el-main  style="padding-top:0px;height: calc(100vh - 90px - 80px)">
        <div style="text-align: center;">
          <img src="/static/img/login-mobile.png" alt="computer" style="width:100%;max-width:1513px">
          <div>
            <h1 style="margin-bottom:30px;">用户登录</h1>
            <el-form ref='loginForm' label-position="right" size="medium"  :model="loginForm" :rules='rules'>
              <van-field v-model="loginForm.username" placeholder="请输入用户名" :error-message='errorUsername' @blur="checkUserName"></van-field>
              <van-field v-model="loginForm.password" placeholder="请输入密码" type='password' :error-message='errorPassword' @blur="checkPassWord"></van-field>
              <template v-if="showVcode">
              <el-form-item  prop='vcode'>
                <el-row :gutter="10">
                    <el-col :span="11">
                      <van-field v-model="loginForm.vcode" placeholder="请输入验证码" :error-message='errorVcode' @blur="checkVcodeMobile" @keyup.enter.native="submitForm"></van-field>
                      <!-- <el-input v-model="loginForm.vcode" @keyup.enter.native="submitForm" placeholder="请输入验证码"></el-input> -->
                    </el-col>
                    <el-col :span="8" style="padding-left:0px;height:44px">
                      <div style="background:#fff;height:44px">
                        <img :src="vcodeSrc" style="margin-top:8px">
                      </div>
                    </el-col>
                    <el-col :span="5" style="text-align:right ">
                      <span id="changeVcode" @click="refreshVcode">换一张</span>
                    </el-col>
                </el-row>
              </el-form-item>
              </template>
              <el-form-item>
                <el-button type="primary" @click="submitForm">登录</el-button>
                <!-- <el-button @click="resetForm">重置</el-button> -->
              </el-form-item>
              <p style="font-size:12px;line-height:25px">忘记登录密码,学生用户请联系任课教师;
                <br>
                教师用户请联系系统管理员</p>
            </el-form>
          </div>

        </div>
      </el-main>
    </div>
    
    <el-footer style="height: 90px; line-height: 30px; padding:40px 0; background-color: #f7f6f4;text-align: center;font-size:13px;width:100%;position:fixed;bottom:0px">
      <div>
        版权所有 © 2001-2023 东软教育科技集团有限公司
        <img :src="srcs" class="Avatar" style="margin-top: 6px">
        <a style="color: #222222;text-decoration:none;cursor: pointer;" @click="openPolicyGOV">辽公网安备 21029602000701号 </a>
        <a style="color: #222222;text-decoration:none;cursor: pointer;" @click="openGOV">辽ICP备19003275号</a>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import { getToken, login } from "./api/api";
export default {
  name: "App",
  data() {
    return {
      isMobile: false,
      showVcode: true,
      vcodeSrc: `/api/v1/cas/vcode?_t=${new Date().getTime()}`,
      srcs:"/static/img/srcs.png",
      loginForm: {
        username: "",
        password: "",
        vcode: ""
      },
      errorUsername:'',
      errorPassword:'',
      errorVcode:'',
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
        vcode: [{ validator: this.checkVcode, trigger: "blur" }]
      }
    };
  },
  created() {
    getToken().then(res => {
      // this.redirectService(res.authCode);
      this.refreshVcode();
    }).catch(res => {
      if (res.response.data.showVcode) {
        this.refreshVcode();
      }
    });
    if(this._isMobile()){
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  methods: {
    openPolicyGOV(){
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21029602000701')
    },
    openGOV(){
      window.open('http://beian.miit.gov.cn/')
    },
    submitForm(){
      if(this._isMobile()) {
        if(this.checkUserName() && this.checkPassWord() && this.checkVcodeMobile()){
          login(this.loginForm.username, this.loginForm.password, this.loginForm.vcode).then(res => {
              this.redirectService(res.authCode, res.userType, true)
          }).catch(res => {
            this.$message.error(res.response.data.message)
            if(res.response.data.showVcode){
              this.refreshVcode()
            }
          });
        }
      }else {
        this.$refs["loginForm"].validate(valid => {
          if (valid) {
            login(this.loginForm.username, this.loginForm.password, this.loginForm.vcode).then(res => {
              this.redirectService(res.authCode, res.userType, true)
            }).catch(res => {
              this.$message.error(res.response.data.message)
              if(res.response.data.showVcode){
                this.refreshVcode()
              }
            });
          }
        });
      }
    },
    checkUserName(){
      if(this.loginForm.username == ''){
        this.errorUsername = '用户名不能为空'
        return false;
      }else {
        this.errorUsername = ''
        return true
      }
    },
    checkPassWord(){
      if(this.loginForm.password == '') {
        this.errorPassword = '密码不能为空'
        return false;
      }else {
        this.errorPassword = ''
        return true;
      }
    },
    checkVcodeMobile(){
      if(this.loginForm.vcode == '') {
        this.errorVcode = '验证码不能为空'
        return false
      }else {
        this.errorVcode = ''
        return true;
      }
    },
    resetForm() {},
    checkVcode(rule, value, callback) {
      if (this.showVcode) {
        if (!this.loginForm.vcode) {
          return callback(new Error("验证码不能为空"));
        }
      }
      return callback();
    },
    refreshVcode() {
      this.showVcode = true;
      this.vcodeSrc = `/api/v1/cas/vcode?_t=${new Date().getTime()}`;
    },
    redirectService(authCode, userType, flag) {
      let serviceUrl = this._getQueryString("service");
      if (serviceUrl) {
        serviceUrl = decodeURIComponent(`${serviceUrl}`);
        let hash = ''
        if (serviceUrl.indexOf('#') != -1) {
          hash = serviceUrl.substring(serviceUrl.indexOf('#'))
          serviceUrl = serviceUrl.substring(0, serviceUrl.indexOf('#'))
        }
        if (serviceUrl.indexOf("authcode=") == -1) {
          if (serviceUrl.indexOf("?") == -1) {
            serviceUrl += "?authcode=" + authCode;
          } else {
            serviceUrl += "&authcode=" + authCode;
          }
        } else {
          let query = serviceUrl.substring(serviceUrl.indexOf("?") + 1);
          let urlPrefix = serviceUrl.substring(0, serviceUrl.indexOf("?"));
          let querys = query.split("&");
          querys.forEach((item, index) => {
            urlPrefix += index == 0 ? "?" : "&";
            if (item.indexOf("authcode=") == 0) {
              urlPrefix += "authcode=" + authCode;
            } else {
              urlPrefix += item;
            }
          });
          serviceUrl = urlPrefix;
        }
        window.location.href = serviceUrl + hash;
      } else if (flag) {

        // 4代表教师，5代表学生，其余代表管理员
        if(userType == 5){
          if(this.isMobile){
            window.location.href = window._nouConfig.mobile_student_ip + "?authcode=" + authCode;
          }else{
            window.location.href = window._nouConfig.student_ip + "?authcode=" + authCode;
          }
        } else if(userType == 4){
          window.location.href = window._nouConfig.teacher_ip + "?authcode=" + authCode;
        } else {
          window.location.href = window._nouConfig.admin_ip + "?authcode=" + authCode;
        }
      }
    },
    _getQueryString(name) {
      let search = window.location.search;
      let queryValue = null;
      if (search) {
        let querys = search.substring(1).split("&");
        querys.forEach(item => {
          let keyValues = item.split("=");
          if (keyValues[0] == name) {
            queryValue = keyValues[1];
            return;
          }
        });
      }
      return queryValue;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
};
</script>
<style scoped>
@media screen and (max-width:800px) and (min-width: 0px) {
  #loginClass{
    background: #f7f8fa;
  }
  .el-header {
    background-color: #f7f8fa !important;
  }
  .header-first{
    background-color: #f7f8fa !important;
  }
  .el-footer {
    position: relative !important;
  }
  #contentId {
    height: calc(100vh - 90px);
  }
}

</style>

<style>
* {
  margin: 0px;
  padding: 0px;
}
html,
body {
  height: 100%;
}
body {
  display: block;
  margin: 0px;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  margin-top: 60px;
  background-color: #f7f6f4;
}
.loginForm {
  position: absolute;
  right: 15%;
  top:3%;
  width: 20%;
  max-width: 350px;
  margin: 0 auto;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 15px 18px 0px rgba(108, 123, 145, 0.15);
  border-radius: 10px;
}
h1 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
}
.el-input--medium .el-input__inner {
  border-radius: 0%;
  border-color: rgb(153, 153, 153);
  margin-bottom: 5px;
}
#changeVcode:hover {
  cursor: pointer;
  color: rgba(22, 155, 213, 1);
}
.el-button--primary {
  width: 100%;
  background-color: rgba(22, 155, 213, 1);
}
#collagelogo{
    float: left;
    height: 100%;
    /* width: 320px; */
    width: 500px;
    background-position-y: 15px;
    background-repeat: no-repeat;
    /* 开放大学 */
    background-image: url('/static/img/logo.png');

    /* 退役军人 */
    /* background-image: url('/static/img/jun-logo.png');
    background-size: 100%; */
    
  }
  #collagelogo2{
    float: left;
    height: 100%;
    width: 320px;
    width: 100%;
    background-position-y: 15px;
    background-repeat: no-repeat;
    /* 开放大学 */
    background-image: url('/static/img/logo.png');

    /* 退役军人 */
    /* background-image: url('/static/img/jun-logo.png');
    background-size: 100%; */
    
  }
  #loginMain{
    border-top:2px solid #2c69ac; 
    /* min-width: 1200px; */
    background-color: #f7f6f4;
  }
  .el-main{
    padding-top: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue